import { ZaiusEvent } from "$gql/mutations/general/ZaiusEvent.gen";
import { useEffect } from "react";
import {
  CookieName,
  useCookie,
  useMutationBundle,
  VuidCookie,
} from "source/hooks";

type ContentType = "nonPartnerBrand";

export enum ZaiusEventType {
  CreateOrUpdateProduct = "/api/zaius/createOrUpdateProduct",
  ProductEvent = "/api/zaius/event",
}
type ProductViewEvent = {
  type: ZaiusEventType.ProductEvent;
  productId: string;
};

type Event = ProductViewEvent;

export function useZaiusEvents(
  events: Event[],
  triggerFunction: () => boolean
) {
  const vuidCookie = useCookie<VuidCookie>(CookieName.Vuid);
  const [trackEvent] = useMutationBundle(ZaiusEvent);

  const triggerResult = triggerFunction();

  useEffect(() => {
    if (triggerResult) {
      for (const event of events) {
        trackEvent({
          variables: {
            vuid: vuidCookie,
            productId: event.productId,
          },
        });
      }
    }
  }, [triggerResult]);
}
